import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getRecoverMerchantNotes = {
  name: "getRecoverMerchantNotes" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ merchantNotes: z.string().nullish() }),
};
